import { Drawer } from 'antd';
import { useFetch } from '../../../../hooks/useFetch/useFetch';
import { useState } from 'react';
import TableLZM from '../../../components/design/table/TableLZM';
import { ButtonLZ } from '../../../components/design/Buttons/ButtonLZ';
import moment from 'moment';
import { DrawerPanelTitle, drawerPanelStyles } from '../../common/Drawers/DrawerPanelTitle';

export const ErrorsDrawer = (props: {
    onFinish: any,
    onClose: any,
    serviceGoogleEmail: any
}) => {

    const [executionsInfo, setExecutionsInfo] = useState(null);

    const { service, googleEmail } = props.serviceGoogleEmail;
    const executionsUrl = googleEmail
        ? `${process.env.REACT_APP_API}/tech/executions/services/${service}?googleEmail=${encodeURIComponent(googleEmail)}`
        : `${process.env.REACT_APP_API}/tech/executions/services/${service}`;

    useFetch(executionsUrl, {}, [],    
    (data: any) => {
        setExecutionsInfo(data);        
    });
    

    const columns: any = [		
        {
			title: 'Fechad de creación',
			key: 'createdDate',						
			render: (text: string, record: any) => (
                <strong>{moment(record.createdDate).format('ll')}</strong>
				)			
		},
        {
			title: 'Message',
			key: 'errorMessage',						
			render: (text: string, record: any) => (
                <>{record.errorMessage}</>
				)			
		},
        {
			title: 'StackTrace',
			key: 'errorStackTrace',						
			render: (text: string, record: any) => (
                <>{record.errorStackTrace}</>
				)			
		}
    ]

    return (

        <Drawer
            placement="right"
            width={'50%'}
            open={true}            
            onClose={props.onClose}
            {...drawerPanelStyles}
            title={
                <DrawerPanelTitle
                    title="Registro de errores"
                    extra={
                        <div>
                            <div>{service}</div>
                            {googleEmail && <div>{googleEmail}</div>}
                        </div>
                    }
                />
            }>

            {executionsInfo &&						
							<TableLZM 
                                scroll={{ x: true, y: 800 }}						
								columns={columns}
								dataSource={executionsInfo}
								loading={false}/>
						}	

        </Drawer>
    )
}

